import { useSiteEmail } from 'hooks/useSiteEmail'

export const SiteEmail = (props) => {
  const siteEmail = useSiteEmail()

  return (
    <a href={`mailto:${siteEmail}`} {...props}>
      {siteEmail}
    </a>
  )
}
